import { useSelector } from 'react-redux';

 
import { getWalletAddress } from '../../redux/selectors';

export const useWalletAddress = (): string | undefined => {
  const walletAddress = useSelector(getWalletAddress);

  return walletAddress;
};
